import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "page-iframe",
  style: {
    "--el-color-primary": "#47fff1"
  },
  "element-loading-text": "页面正在加载中...",
  "element-loading-background": "rgba(122, 122, 122, 0.8)"
};
const _hoisted_2 = ["src"];
import { useRouter } from "vue-router";
import { computed, ref, onMounted } from "vue";
export default {
  __name: 'ExternalPage',
  setup(__props) {
    const loading = ref(true);
    const router = useRouter();
    const externalUrl = computed(() => {
      loading.value = true;
      return router.currentRoute.value.query.url || "about:blank";
    });

    // 设置标题
    document.title = router.currentRoute.value.query.title;
    const onIframeLoad = () => {
      loading.value = false;
    };
    return (_ctx, _cache) => {
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("iframe", {
        src: externalUrl.value,
        class: "iframe",
        onLoad: onIframeLoad
      }, null, 40, _hoisted_2)])), [[_directive_loading, loading.value]]);
    };
  }
};